import { useState } from "react";
import SectionHeader from "shared/components/Header/SectionHeader";
import styles from "./Contact.module.css";
import { isSupabaseConfigured, supabase } from "shared/services/supabase";
import { trackContactFormSubmit } from "shared/services/analytics";

const INITIAL_FORM_VALUES = {
  name: "",
  email: "",
  message: "",
};

const Contact = () => {
  const [formData, setFormData] = useState(INITIAL_FORM_VALUES);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("idle");
  const [feedbackMessage, setFeedbackMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    if (status !== "idle") {
      setStatus("idle");
      setFeedbackMessage("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!isSupabaseConfigured || !supabase) {
      setStatus("error");
      setFeedbackMessage(
        "Contact form is temporarily unavailable. Please try again later."
      );
      trackContactFormSubmit(false);
      return;
    }

    setLoading(true);
    setStatus("idle");
    setFeedbackMessage("");

    const payload = {
      name: formData.name.trim(),
      email: formData.email.trim(),
      message: formData.message.trim(),
    };

    try {
      const { error } = await supabase.from("Contact").insert([payload]);

      if (error) {
        throw error;
      }

      setStatus("success");
      setFeedbackMessage("Message sent successfully!");
      setFormData(INITIAL_FORM_VALUES);
      trackContactFormSubmit(true);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error submitting contact form", error);
      setStatus("error");
      setFeedbackMessage("Failed to send message.");
      trackContactFormSubmit(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <SectionHeader
          title="Let's Create Something Amazing"
          isTextBold={true}
        />
        <div className={styles.formContainer}>
          <form className={styles.form} onSubmit={handleSubmit}>
            <label htmlFor="name" className={styles.label}>Name</label>
            <input
              id="name"
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              className={styles.input}
              required
            />
            <label htmlFor="email" className={styles.label}>Email</label>
            <input
              id="email"
              type="email"
              name="email"
              placeholder="Your@email.com"
              value={formData.email}
              onChange={handleChange}
              className={styles.input}
              required
            />
            <label htmlFor="message" className={styles.label}>Message</label>
            <textarea
              id="message"
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              className={styles.textarea}
              required
            ></textarea>
            <button type="submit" className={styles.button} disabled={loading}>
              {loading ? "Sending..." : "Send"}
            </button>
            {status !== "idle" && (
              <p
                aria-live="polite"
                className={status === "success" ? styles.success : styles.error}
              >
                {feedbackMessage}
              </p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
